import React, { FC } from 'react';

// components
import ImageAlternatePreview from '../../../editors/PushNotificationEditor/Editor/components/Image/ImageAlternatePreview';
import styled from 'styled-components';

// theme
import aampeTheme from '../../../constants/aampeTheme';

import { hexToRgba } from 'helpers/random';

import useComponentTypesQuery from '../../../hooks/component-types/useComponentTypesQuery';

import ComponentTypesIconWrapper from '../../componentTypesIcon/ComponentTypesIconWrapper';

interface StyledProps {
    variantColor: string;
    isVariant?: boolean;
    textColor?: string;
}

interface FormulaVariantChipProps {
    title: string;
    variantType: string;
}

const FormulaVariantChip: FC<React.PropsWithChildren<FormulaVariantChipProps>> =
    ({ title, variantType }) => {
        const { data } = useComponentTypesQuery();

        const componentType = data?.map[variantType];

        const isImage = componentType?.additional_metadata?.is_image;
        const primaryColor = componentType?.base_color || '';
        const textColor = componentType?.text_color || '';

        if (!componentType) return null;

        return (
            <Container>
                {title && (
                    <Chip
                        variantColor={primaryColor}
                        isVariant={!!variantType}
                        textColor={textColor}
                    >
                        {isImage ? (
                            <ImageAlternatePreview text={title} />
                        ) : variantType ? (
                            <IconContent>
                                <ComponentTypesIconWrapper
                                    dataKey={componentType?.data_key}
                                />
                                {title}
                            </IconContent>
                        ) : (
                            title
                        )}
                    </Chip>
                )}
            </Container>
        );
    };

const Container = styled.div({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
});

const Chip = styled.div.withConfig({
    shouldForwardProp: (prop) =>
        !['isVariant', 'variantColor', 'textColor'].includes(prop),
})<StyledProps>(({ isVariant, variantColor, textColor }) => ({
    padding: isVariant ? aampeTheme.spacing4(3) : aampeTheme.spacing4(3, 0),
    color: textColor,
    border: isVariant ? '1px solid' : 'none',
    fontSize: aampeTheme.size.font.textMedium,
    borderRadius: aampeTheme.borderRadius.default,
    wordBreak: 'break-word',
    borderColor: isVariant ? hexToRgba(variantColor, 0.1) : 'none',
}));

const IconContent = styled.div({
    display: 'flex',
    alignItems: 'center',
    gap: aampeTheme.spacing4(3),
});

export default FormulaVariantChip;
